import React from "react";
import { ArrowDownIcon2, MoneyIcon, StackIcon } from "../SVGIcons";
import clsx from "clsx";
import AnimatedContent from "../AnimatedContent";

const Item = ({ title, description, index, icon }: { title: string, description: string, index: string, icon: React.ReactNode }) => {
    return <div className="flex flex-col gap-[40px] relative">
        <div className="flex justify-center relative">
            <div className="w-[68px] h-[68px] bg-black rounded-full border border-dashed border-white flex items-center justify-center text-[#00FFEE] text-[16px] font-medium relative z-[2]">
                {index}
            </div>
            <div className={clsx(
                "h-[1px] bg-[#161616] top-[50%] translate-y-[-50%] absolute hidden",
                "md:h-[1px] md:top-[50%] md:translate-y-[-50%] md:absolute md:block",
                index === "01" ? "w-[50%] right-0" : index === "02" ? "w-[100%] right-0" : "w-[50%] left-0"
            )} />
        </div>
        <div className="flex flex-col items-center px-[16px] pb-[37px]">
            {icon}
            <div className="text-start text-[20px] font-medium leading-[1.2] tracking-[-0.8px] mt-[24px]">{title}</div>
            <div className="mt-[12px] truncate text-[14px] text-white/70">
                {description}
            </div>
        </div>
    </div>;
};

const HowTaoFlowWorks = () => {
    return <div className="w-full border-b border-[#161616]">
        <div className={clsx(
            "relative flex flex-col items-center gap-[40px] pt-[40px] px-[16px] w-full max-w-[1072px] mx-auto",
            "md:pt-[120px]"
        )}>
            <AnimatedContent>
                <div className={clsx(
                    "relative z-[2] text-center text-[32px] font-semibold leading-[1.2] tracking-[-1.84px]",
                    "md:text-[46px]"
                )}>
                    How Taoflow Works
                </div>
            </AnimatedContent>
            <AnimatedContent>
                <div className={clsx(
                    "flex items-center flex-col w-full",
                    "md:flex-row md:items-end"
                )}>
                    <div className="flex-1">
                        <Item
                            title="Deposit TAO"
                            description="pooled & earning baseline yield"
                            index="01"
                            icon={<div>
                                <ArrowDownIcon2 fillColor="#00FFEE" className="w-[40px] h-[40px]" />
                            </div>}
                        />
                    </div>
                    <div className="flex-1 relative">
                        <div className={clsx(
                            "w-[1px] h-[174px] bg-gradient-to-t from-[#161616] to-[#161616]/0 absolute bottom-0 left-0 hidden",
                            "md:block"
                        )} />
                        <Item
                            title="Trade with Power"
                            description="Borrow up to 10x collateral"
                            index="02"
                            icon={<div>
                                <MoneyIcon fillColor="#00FFEE" className="w-[40px] h-[40px]" />
                            </div>}
                        />
                        <div className={clsx(
                            "w-[1px] h-[174px] bg-gradient-to-t from-[#161616] to-[#161616]/0 absolute bottom-0 right-0 hidden",
                            "md:block"
                        )} />
                    </div>
                    <div className="flex-1">
                        <Item
                            title="Trade with Power"
                            description="Borrow up to 10x collateral"
                            index="03"
                            icon={<div>
                                <StackIcon fillColor="#00FFEE" className="w-[40px] h-[40px]" />
                            </div>}
                        />
                    </div>
                </div>
            </AnimatedContent>
        </div >
    </div>;
};

export default HowTaoFlowWorks;
